import { NavLink } from 'react-router-dom';
import { BrandLogo } from '../BrandLogo';
import { can, isAdmin, useStaffMe } from '../../lib/permissions';

interface AdminSidebarProps {
  onHide: () => void;
}

function navClass({ isActive }: { isActive: boolean }): string {
  return `admin-sidebar__item${isActive ? ' admin-sidebar__item--active' : ''}`;
}

export function AdminSidebar({ onHide }: AdminSidebarProps): JSX.Element {
  const meQuery = useStaffMe();
  const me = meQuery.data;
  const showClients = isAdmin(me) || can(me, 'clients', 'view');
  const showStaff = isAdmin(me);

  return (
    <aside className="admin-sidebar" aria-label="HQ modules">
      <div className="admin-sidebar__brand">
        <BrandLogo small />
        <button className="admin-sidebar__hide" type="button" onClick={onHide} aria-label="Hide module rail">
          «
        </button>
      </div>
      <div className="admin-sidebar__sections">
        <nav className="admin-sidebar__section" aria-label="Registry modules">
          <p className="admin-sidebar__subheading">Registry</p>
          <div className="admin-sidebar__nav">
            {showClients ? (
              <NavLink className={navClass} to="/clients">
                Clients
              </NavLink>
            ) : null}
            <NavLink className={navClass} to="/device-catalog">
              Device catalog
            </NavLink>
            <NavLink className={navClass} to="/manufactured-devices">
              Manufactured
            </NavLink>
          </div>
        </nav>
        <nav className="admin-sidebar__section" aria-label="Account modules">
          <p className="admin-sidebar__subheading">Account</p>
          <div className="admin-sidebar__nav">
            <NavLink className={navClass} to="/account">
              My account
            </NavLink>
            {showStaff ? (
              <NavLink className={navClass} to="/staff">
                Staff
              </NavLink>
            ) : null}
          </div>
        </nav>
      </div>
    </aside>
  );
}
